/* Maison Ella — wishlist hearts (PDP, COMPLETE THE LOOK and PDP recommendations).
 *
 * The hearts are rendered by the theme so their position is ours, not Swym's.
 * Swym remains the owner of the wishlist; this only calls its API.
 *   - Clicks are delegated from the document, so hearts in cards that load
 *     later (Frequently bought together, Recently viewed) work too.
 *   - Saved state is painted on every heart that appears, including late ones.
 *   - If Swym never loads, the hearts hide rather than sit there inert.
 */
(function () {
  'use strict';

  if (window.pdpbWishlist) return;
  window.pdpbWishlist = true;

  var SELECTOR = '[data-pdpb-wish]';
  var swat = null;
  var saved = {};

  function itemFor(btn) {
    return {
      empi: parseInt(btn.getAttribute('data-product-id'), 10),
      epi: parseInt(btn.getAttribute('data-variant-id'), 10),
      du: window.location.origin + btn.getAttribute('data-product-url')
    };
  }

  function paint(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-wished', !!on);
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function paintAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (btn) {
      paint(btn, !!saved[parseInt(btn.getAttribute('data-product-id'), 10)]);
    });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest(SELECTOR);
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (!swat || btn.dataset.busy) return;
    btn.dataset.busy = '1';

    var on = btn.getAttribute('aria-pressed') === 'true';
    var id = parseInt(btn.getAttribute('data-product-id'), 10);
    var done = function (ok) {
      delete btn.dataset.busy;
      if (!ok) return;
      if (on) { delete saved[id]; } else { saved[id] = true; }
      // every heart for the same product stays in step
      document.querySelectorAll(SELECTOR + '[data-product-id="' + id + '"]').forEach(function (b) { paint(b, !on); });
    };
    var item = itemFor(btn);
    if (on) {
      swat.removeFromWishList(item, function () { done(true); }, function () { done(false); });
    } else {
      swat.addToWishList(item, function () { done(true); }, function () { done(false); });
    }
  }, true);

  // Keep the main product's heart on the selected variant. Card hearts carry
  // their own products and must not take the main ring's variant.
  document.addEventListener('variant:change', function (evt) {
    var v = evt && evt.detail && evt.detail.variant;
    if (!v) return;
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      if (btn.classList.contains('pdpb-wish--card') || btn.classList.contains('pdpb-wish--grid')) return;
      btn.setAttribute('data-variant-id', v.id);
    });
  });

  function ready(s) {
    swat = s;
    document.documentElement.classList.add('pdpb-swym-ready');
    document.querySelectorAll('#swym-atw-button-container').forEach(function (el) { el.setAttribute('hidden', ''); });
    try {
      swat.fetch(function (list) {
        (list || []).forEach(function (row) { if (row && row.empi) saved[row.empi] = true; });
        paintAll();
      }, function () {});
    } catch (e) {}
    // hearts in cards that arrive later
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (n.matches(SELECTOR) || n.querySelector(SELECTOR))) paintAll(n.parentNode || n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(ready);

  // No Swym after a generous wait: hide the hearts rather than show dead ones.
  window.setTimeout(function () {
    if (swat) return;
    document.documentElement.classList.add('pdpb-swym-missing');
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      var slot = btn.closest('.product__submit__item') || btn;
      slot.setAttribute('hidden', '');
    });
  }, 8000);
})();
